export default class VoyageFuelCreateData {
    constructor(
        cost,
        ncv,
        tag,
        type,
    ) {
        this.cost = cost;
        this.ncv = ncv;
        this.tag = tag;
        this.type = type;
    }
}